



















































import { Component, Emit, Prop, Vue } from 'vue-property-decorator'
import { Apis, Factories, Services } from '@finx/web-repository'
import StoreRelatorios from '@/store/Relatorios'

@Component

export default class ComponentRelatoriosFiltros extends Vue {
  @Prop(String) typeReport

  prestadores: any[] = []
  profissionaisExecutantes: any[] = []

  user: any = {}

  loadings: any = {
    getPrestadores: false,
    getProfissionaisExecutantes: false,
  }

  get contratoId(): any {
    return StoreRelatorios.getters.CONTRATO_ID
  }

  set contratoId(newValue) {
    StoreRelatorios.commit('CONTRATO_ID', newValue)
  }

  get prestador(): any {
    return StoreRelatorios.getters.PRESTADOR
  }

  set prestador(newValue) {
    if (newValue) this.contratoId = newValue.contratoId

    StoreRelatorios.commit('PRESTADOR', newValue)
  }

  get profissionalExecutante(): any {
    return StoreRelatorios.getters.PROFISSIONAL_EXECUTANTE
  }

  set profissionalExecutante(newValue) {
    StoreRelatorios.commit('PROFISSIONAL_EXECUTANTE', newValue)
  }

  async mounted() {
    if (this.typeReport === 'recebimento') {
      await this.getPrestadoresUserGestor()
    } else {
      await this.getPrestadores()
    }
  }

  async getPrestadoresUserGestor() {
    this.prestador = {}

    const request = await Apis.Contratos.Prestadores.getPrestadoresUserGestor()
    const success = Factories.Apis.success(request)

    if (success) {
      const prestadores = request.data
      this.prestadores = prestadores
    }
  }

  async getPrestadores() {
    const request = await Apis.Legacy.Producao.getPrestadoresByUser()
    const success = Factories.Apis.success(request)

    if (success) {
      const prestadores = request.data
      this.prestadores = prestadores
    }
  }

  async getProfissionaisExecutantes() {
    this.loadings.getProfissionaisExecutantes = true
    this.profissionalExecutante = {}

    const request = await Apis.Contratos.ProfissionaisExecutantes.getProfissionaisExecutantesByPrestadorId(this.prestador.id)
    const success = Factories.Apis.success(request)

    if (success) {
      this.profissionaisExecutantes = request.data
    }

    this.loadings.getProfissionaisExecutantes = false
  }

  resetForm() {
    this.prestador = {}
    this.profissionalExecutante = {}
  }

  @Emit('getRelatorio')
  getRelatorio() {}
}
